// extracted by mini-css-extract-plugin
export default {"toolbar":"WorkspaceToolbar_toolbar__JPGYv"};